module.exports = __webpack_public_path__ + "img/dlybg06.37f12996.png";